import PropTypes from 'prop-types';

import { SliceZone } from './components';

export default function SolutionsDetails({ doc }) {
  return <SliceZone slices={doc.data?.body || []} />;
}

SolutionsDetails.propTypes = {
  doc: PropTypes.object,
};
